import { styled } from "@mui/material";
import { ReactNode } from "react";

export function Header(props: { texts: string[] }) {
  return (
    <div style={{ display: "flex", padding: 12, gap: 24, borderBottom: "1px solid #878787" }}>
      {props.texts.map((text , index) => (
        <div key={index}>{text}</div>
      ))}
    </div>
  );
}

export function Card(props: { title: string; items: CardItemProps[]; children?: ReactNode }) {
  return (
    <div style={{ backgroundColor: "#f9fafe", borderRadius: 8, padding: 24 }}>
      <h4 style={{ borderBottom: "1px solid #878787", paddingBottom: 12 }}>{props.title}</h4>
      <div
        style={{ display: "flex", justifyContent: "space-between", gap: 24, flexWrap: "wrap", maxWidth: 250 }}
      >
        {props.children || props.items.map((item, index) => <CardItem key={index} {...item} />)}
      </div>
    </div>
  );
}

interface CardItemProps {
  title: string;
  count?: number;
  price?: number;
}

export function CardItem({ title, count, price }: CardItemProps) {
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 6 }}>
        <span>{title}</span>
        {count && <CountCard>{count}</CountCard>}
      </div>
      {price && <div>{Intl.NumberFormat().format(price)}</div>}
    </div>
  );
}

export const CountCard = styled("span")(() => ({
  borderBottom: "1px solid #878787",
  width: 20,
  height: 20,
  textAlign: "center",
}));
